module.exports = __webpack_public_path__ + "static/media/23.1e30ef44.jpg";